import React from "react";

export default function Web_HTTP() {
  return (
    <div>
      <h1>What is HTTP</h1>
      <p>
        Route: <code>/web/http</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
